<template>
	<div>
		<vs-popup id="VxModal" :class="nameClass" class="Modal-Choice" :title="title" :active.sync="popupActive">
	      <slot name="body"></slot>
	    </vs-popup>
	</div>
	
</template>

<script type="text/javascript">
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import {  mapState, mapMutations } from 'vuex';	
	export default {
		name: 'VxModal',
		props: {
			title: {
				type: String,
				required: false,
				default: 'Popup'
			},	
			width: {
				type: String,
				required: false,
				default: '60%'
			},
			nameClass: {
				type: String,
				required: false,
				default: ''
			}		
		},	
		mounted() {
			this.setWidth();
		},
		data() {
			return {
				SelectedHeaders:  '',
				previewData: [],
				isChecked: false,
				originKey: '',
				cantRegister: 20		
			}
		},
		methods: {
			...mapMutations('resource',['UPDATE_STATE']),
			closedPopup(event) {
				this.UPDATE_STATE({key:'activePopup', value: false});
				this.UPDATE_STATE({key:'componentPopup', value: ''});				
			},
		    setSidebarWidth() {
		        if (this.windowWidth < 992) {
                   let element = document.querySelector('#VxModal .vs-popup');
                   element.style.width = '80%';	 	            
		        } else {
                    let element = document.querySelector('#VxModal .vs-popup');
        			element.style.width = this.width;	
		        }
		    },
		    setWidth() {
		    	let element = document.querySelector('#VxModal .vs-popup');
		    	element.style.width = this.width;
		    }
		},
		computed: {
			...mapState('resource',['activePopup']),			
			popupActive: {
				get() {
					return this.activePopup;
				},
				set(value) {					
					this.UPDATE_STATE({key:'activePopup', value: false});
					setTimeout(() => { this.UPDATE_STATE({key:'componentPopup', value: ''}); }, 50);
					
				}
			},	
			windowWidth() { return this.$store.state.windowWidth; },	
		},
		watch: {
		    windowWidth() {
		        this.setSidebarWidth();
		    },
		    width() {
		    	this.setWidth();
		    }	 
		},	
	}
</script>

<!-- <style type="text/css" lang="scss">
	@import './style.scss';
</style> -->

<style type="text/css">
	.Modal-Choice .vs-popup--background {
		background-color: rgba(250,250,250, .2)!important;
	}
	.Modal-Choice .vs-popup {		
		box-shadow: 0px 0px 5px -1px rgba(0,0,0,0.75);
		border-radius: 0px;
	}

	.Modal-Choice .vs-popup .vs-popup--header {
		height: 60px;
		background: white;
		border-bottom: 1px solid rgba(110,110,110, .5);
		border-radius: 0px;
	}
	
	.Modal-Choice .vs-popup .vs-popup--close {
		-webkit-transform: none!important;
		transform: none!important;
		-webkit-box-shadow: none!important;
		box-shadow: none!important;
	}

	.Modal-Choice .vs-popup .vs-popup--content {
		padding: 0px!important;		
		width: 100%!important;
	}
</style>